module.exports = __webpack_public_path__ + "app/community/modals/modal-delete-cooperative-NhqjIyYw.html";